var map = {
	"./restaurant1.jpg": 7882,
	"./restaurant10.jpg": 2043,
	"./restaurant11.jpg": 780,
	"./restaurant12.jpg": 1747,
	"./restaurant13.jpg": 4458,
	"./restaurant14.jpg": 2751,
	"./restaurant15.jpg": 2175,
	"./restaurant16.jpg": 1629,
	"./restaurant17.jpg": 8770,
	"./restaurant18.jpg": 4683,
	"./restaurant19.jpg": 4730,
	"./restaurant2.jpg": 4783,
	"./restaurant20.jpg": 8194,
	"./restaurant21.jpg": 4584,
	"./restaurant3.jpg": 8523,
	"./restaurant4.jpg": 3023,
	"./restaurant5.jpg": 3614,
	"./restaurant6.jpg": 1405,
	"./restaurant7.jpg": 1166,
	"./restaurant8.jpg": 4107,
	"./restaurant9.jpg": 8534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3116;